import { render, staticRenderFns } from "./CSidebarNav.vue?vue&type=template&id=685ea76e"
import script from "./CSidebarNav.vue?vue&type=script&lang=js"
export * from "./CSidebarNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports